import React from 'react';
import {useTranslation} from 'react-i18next';
import ConfirmModal from '../../../incase-domain/components/modals/confirmModal/ConfirmModal';
import {ConnectionRequestStatus} from '../../../incase-domain/connection';
import {INotification, NotificationType} from '../../../incase-domain/notification';

interface NotificationModalProps {
    notification: INotification;
    title: () => JSX.Element | string;
    message: () => JSX.Element | string;
    isOpen: boolean;
    onClose: () => void;
    actionButtons: () => JSX.Element;
}

function NotificationModal({notification, title, message, isOpen, onClose, actionButtons}: NotificationModalProps): JSX.Element {
    const {t} = useTranslation();
    function getIcon(): string {
        switch (notification.type) {
            case NotificationType.CONNECTION:
                return notification.connectionRequest.status === ConnectionRequestStatus.ACCEPTED
                    ? 'solar:users-group-rounded-linear'
                    : 'solar:user-hand-up-linear';
            case NotificationType.SEND_PRESENTATION:
                return 'solar:letter-linear';
            case NotificationType.SHARE_PRESENTATION:
                return 'solar:share-linear';
            case NotificationType.INVALID_PASSWORD:
            case NotificationType.PRES_PASS_EXPIRED:
                return 'solar:lock-password-linear';
            default:
                return '';
        }
    }

    function getInfo(): string {
        switch (notification.type) {
            case NotificationType.CONNECTION:
                return t('notifications.connectionRequest.info');
            default:
                return '';
        }
    }

    return (
        <ConfirmModal
            isOpen={isOpen}
            onCancel={onClose}
            icon={getIcon()}
            iconSize="lg"
            title={title()}
            message={message()}
            showConfirm={false}
            showCancel={false}
            color="info"
        >
            <div className="u-flex u-justify-between u-h-center u-mt-4">
                <div>
                    <div className="u-flex u-h-center u-gap-1">{actionButtons()}</div>
                    {getInfo() && (
                        <p style={{fontSize: '.75em'}} className="u-mt-2">
                            {getInfo()}
                        </p>
                    )}
                </div>
            </div>
        </ConfirmModal>
    );
}

export default NotificationModal;
